<template>
  <el-dialog
  :visible="prDialogVisible"
  :close-on-press-escape="false"
  :show-close="false"
  append-to-body
  center
  :fullscreen="true"
  v-loading="loading"
  @open="open">
  <span slot="title" class="dialog-header">
    <span  class="title" >Demande de réception</span>
  </span>
  <el-row justify="center">
    <el-col class="formContainer" :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
      <el-form label-position="top" label-width="100px" :model="purchaseReceive" :rules="rules" ref="prForm">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
              <el-form-item label="Date de réception" prop="date">
                <el-date-picker v-model="dateModel" type="date" placeholder="Sélectionner une date" :picker-options="datePickerOptions"></el-date-picker>
              </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
            <el-form-item>
              <el-checkbox :value="purchaseReceive.receiveAll" @change="setComplete">Indiquer comme étant complètement reçu.</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!receiveAll || considerItemPriceVariation">
          <el-table
            :data="purchaseReceive.items"
            border
            style="width: 100%"
            :row-class-name="tableRowClassName"
            v-loading="prItemsLoading">
            <el-table-column
              align="center"
              width="80">
              <template slot-scope="scope">
                <el-switch
                  :disabled="scope.row.qty_received >= scope.row.qty_ordered"
                  :value="scope.row.receiveInd"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="v => setReceiveInd(scope.$index, v)"/>
              </template>
            </el-table-column>
            <el-table-column
              label="Nom">
              <template slot-scope="scope">
                <productItemDefinition
                  :product="scope.row.product"
                  :name="scope.row.product.name"
                  :sku="scope.row.product.sku"
                  :product_unit="scope.row.product.unit"
                  :product_uvc="scope.row.product.uvc"
                  :description="scope.row.purchase_description" >
                </productItemDefinition>

                <el-form-item required label="Code de lot" :error="scope.row.referenceError">
                  <el-input :disabled="!scope.row.receiveInd" :value="scope.row.reference" @input="v => setReference(scope.$index, v)" />
                    <div slot="error" style="white-space:normal;line-height:23px;" ><span class="danger-text">{{scope.row.referenceError}}</span></div>
                    <br>
                    <el-button
                      size="mini"
                      :disabled="!scope.row.receiveInd"
                      v-if="scope.row.cannotMerge === false && scope.row.reference != null && scope.row.reference !== '' && scope.row.itemToMerge != null"
                      @click="setMergeItem(scope.$index, !scope.row.mergeItem)"
                      >
                      <span v-if="!scope.row.mergeItem"><i class="el-icon-check mr-5" />Ajouter dans le même lot</span>
                      <span v-else><i class="el-icon-close mr-5" />Ne pas ajouter dans le même lot</span>
                    </el-button>

                    <!-- <el-checkbox slot="reference" :disabled="!scope.row.receiveInd" v-if="scope.row.cannotMerge === false && scope.row.reference != null && scope.row.reference !== ''" :value="scope.row.mergeItem" @change=" v=> setMergeItem(scope.$index, v)">Ajouter dans le même lot</el-checkbox> -->
                </el-form-item>

              </template>
            </el-table-column>
            <el-table-column
              label="Qte. commandée"
              align="center"
              width="130">
              <template slot-scope="scope">
                <div v-if="calculateQuantityUVC">
                  <span>{{Math.ceil(scope.row.qty_ordered/scope.row.product.uvc)}} {{$t(getProductUnit(scope.row.product.unit))}}(s)</span><br>
                  <span>{{scope.row.qty_ordered}} Unité(s)</span>
                </div>
                <span v-else>{{scope.row.qty_ordered}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="Qte. reçue"
              align="center"
              width="130">
              <template slot-scope="scope">
                <div v-if="calculateQuantityUVC">
                  <span>{{Math.ceil(scope.row.qty_received/scope.row.product.uvc)}} {{$t(getProductUnit(scope.row.product.unit))}}(s)</span><br>
                  <span>{{scope.row.qty_received}} Unité(s)</span>
                </div>
                <span v-else>{{scope.row.qty_received}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="Qte. à recevoir"
              align="center"
              width="200">
              <template slot-scope="scope">
                <unitQuantities
                  v-if="!scope.row.in_correction"
                  :disabled="scope.row.in_correction || !scope.row.receiveInd"
                  @change="v => setQtyToReceive(scope.$index, v)"
                  :default="scope.row.qty_to_receive"
                  :product_unit="scope.row.product.unit"
                  :product_uvc="scope.row.product.uvc"
                  :min="1"
                  :max="scope.row.qty_ordered - scope.row.qty_received"
                  @unitQuantitiesFocus="localLoading=true;"
                    @unitQuantitiesBlur="localLoading=false;"
                    :default_unit="2">
                  </unitQuantities>
                <span v-else class="fs-14 secondary-text">Impossible de réceptionner un item en correction. Veuillez enlever le statut de correcton sur l'item avant de le réceptionner.</span>
              </template>
            </el-table-column>
            <el-table-column v-if="considerItemPriceVariation"
              label="Prix"
              align="center"
              prop="price"
              width="200"
            >
              <template slot-scope="scope">
                <div >
                  <span v-show="!isSAQ">
                    <span>Prix coûtant</span><br>
                    <el-input-number  :value="scope.row.purchase_unit_price" :controls="false" style="width:120px" :disabled="!scope.row.receiveInd || scope.row.mergeItem" @input="v => setPurchaseUnitPrice(scope.$index, v)"></el-input-number>
                    <br>
                  </span>
                  <span v-show="scope.row.product.agency_rate == null">
                    <span>Prix référentiel</span><br>
                    <el-input-number   :disabled="true" :value="scope.row.selling_unit_price" :controls="false" style="width:120px" ></el-input-number>
                    <br>
                  </span>
                  <span>{{labelPrice}}</span>
                  <br>
                  <el-input-number   :disabled="!scope.row.receiveInd || scope.row.mergeItem" :value="scope.row.price" :controls="false" :min="0" style="width:120px" @input="v => setPrice(scope.$index, v)" />
                  <span v-if="isSAQ">
                    <br>
                    <span>Prix SAQ</span><br>
                    <el-form-item :error="scope.row.itemPriceError" style="margin-bottom:50px;word-break: break-word;">
                      <el-input-number :controls="false" :value="scope.row.price_tax_in" :disabled="scope.row.qty_to_receive==0 || !scope.row.receiveInd || scope.row.mergeItem" style="width:120px" @input="v => setPriceTaxIn(scope.$index, v)" />
                    </el-form-item>
                  </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-row style="margin-top:20px;">
          <el-form-item>
            <el-input type="textarea" :rows="6" placeholder="Saisir une note" v-model="notes"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
    </el-col>
  </el-row>

  <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">Annuler</el-button>
    <el-button type="primary" @click="createPR" :disabled="loading==true || localLoading==true">Enregistrer</el-button>
  </span>
  </el-dialog>
</template>
<script>
import axios from "axios"

import { mapActions, mapState, mapGetters } from 'vuex';
import moment from 'moment-timezone';
import productUtils from '@/utils/portaus-utils';
import unitQuantities from '@/components/product/unit-quantities';
import productItemDefinition from '@/components/product/product-item-definition';

export default {
  name: 'PurchaseReceiveDialog',
	props: {
		prDialogVisible : Boolean,
    purchaseOrder : Object,
    receiveAll : {
      type : Boolean,
      default : true
    }
	},
  data() {
    var validateReference = (rule, value, callback) => {
      if (this.isIP) {
        const regex = /\d-{1}\d/gm;
        const found = value.match(regex);
        if (found == null) {
          callback(new Error("Veuillez assurer de saisir le code de lot d'arrivage composé de chiffre séparé par un tiret."));
        }
       
      } else {
        callback();
      }
    };
    return {
      pr : {
        date : null,
      },
      purchaseReceives : [],
      rules : {
        date : [
          { required: true, message: 'Veuillez saisir une date', trigger: 'blur' }
        ],
        price : [
          { required: true, message: 'Veuillez saisir un prix', trigger: 'blur' }
        ],
        reference : [
          { required: true, message: 'Veuillez saisir un code de lot SAQ', trigger: 'blur' },
          { validator: validateReference, trigger: 'blur' },
        ]
      },
      datePickerOptions: {
          disabledDate :this.chooseDateMinusOrEqualToNow
        },
      prItemsLoading : false,
      complete : false,
      itemPriceError : null,
      localLoading : false,
    };
  },components: {
    unitQuantities,
    productItemDefinition,
  },
	methods: {
    tableRowClassName({row, rowIndex}) {
        if (row.in_correction) {
          return 'warning-row';
        } else if (row.purchase_status.qty_received==row.purchase_status.qty_ordered) {
          return 'success-row';
        }
        return '';
      },
    setMergeItem (index, mergeItem){
      if (mergeItem) {
        this.$confirm('Les informations tel le prix, le prix coûtant et la date de disponibilité du lot resteront inchangés. Seulement la quantité du lot augmentera. Continuer?', 'Ajout au lot existant', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(() => {
          this.setLineProp({index, lineProp:{mergeItem}});
        }).catch(() => {
          /* do nothing */
        });
      } else {
        this.setLineProp({index, lineProp:{mergeItem}});
      }
    },
    setReference(index, reference){
      this.setLineProp({index, lineProp:{reference}});
    },
    setReceiveInd(index, receiveInd){
      this.setLineProp({index, lineProp:{receiveInd}});
    },
    setQtyToReceive(index, qty_to_receive){
      // console.log(qty_to_receive);
      this.setLineProp({index, lineProp:{qty_to_receive}});
    },
    setPurchaseUnitPrice(index, purchase_unit_price) {
      this.setLineProp({index, lineProp:{purchase_unit_price}});
    },
    setPrice(index, price){
      //validation basé sur le maximum de variation si CONSIDER_ITEM_PRICE_VARIATION activé
      this.setLineProp({index, lineProp:{price}});
      // this.validateItemPriceVariation(index).then(()=>{}).catch(err=>{});

    },
    setPriceTaxIn(index, price_tax_in){
      //validation basé sur le maximum de variation si CONSIDER_ITEM_PRICE_VARIATION activé
      this.setLineProp({index, lineProp:{price_tax_in}});
      // this.validateItemPriceVariation(index).then(()=>{}).catch(err=>{});

    },
    setComplete(receiveAll){
      this.setPurchaseReceiveProp({receiveAll})
    },
    open(){
      this.reset();
      this.pr = {};
      this.complete = this.receiveAll
      this.initPurchaseReceive({purchaseOrder:this.purchaseOrder, receiveAll:this.receiveAll});
    },
    closeDialog(){
      this.$emit('close');
    },
    chooseDateMinusOrEqualToNow (date) {
        return  date > new Date();
    },
    sendPostPR(){
      this.postReceiveOrder()
        .then(purchaseReceiveOrderCreated=>{
          this.$emit('created',purchaseReceiveOrderCreated);
          this.invalidAndUpdateSelectedPurchaseOrder();
          this.$emit('close');
        }).catch(err=>{
          if (err === 'ITEMS_EMPTY') {
            this.$message({
                  message: "Impossible d'enregistrer la réception car aucun élément n'a été sélectionné!",
                  type: 'error'
                });
          } else if(err === 'REFERENCE_ERROR') {
            this.$message({
                  message: "Le code de lot d'un ou plusieurs items est erroné!",
                  type: 'error'
                });
          } else {
            this.$message({
                  message: 'Une erreur système est survenue. Veuillez réessayer plus tard.',
                  type: 'error'
                });
          }
        })
    },
    createPR(){
      this.$refs['prForm'].validate(valid=>{
        if(valid && this.isQuantityToReceiveIsValid()){
          this.sendPostPR();
        }else{
          this.$message({
                message: "Certains champs obligatoires n'ont pas été renseignés ou le formulaire contient des erreurs.",
                type: 'error'
              });
        }
      });
    },
    getProductUnit(unit){
      return productUtils.getFormattedUnit_i18n(unit);
    },
    ...mapActions('purchaseOrders',['invalidAndUpdateSelectedPurchaseOrder']),
    ...mapActions('purchaseReceiveDialog', ['validateItemPriceVariation','reset','setPurchaseReceiveProp','initPurchaseReceive','postReceiveOrder','setLineProp']),
    ...mapGetters('purchaseReceiveDialog',['isQuantityToReceiveIsValid']),
    ...mapGetters('purchaseOrders',['is_line_in_correction'])
	},
	computed: {
    isIP(){
      return _.get(this.inventory, 'code') === 'IP';
    },
    isSAQ(){
      return this.inventory != null && (this.inventory.code === 'IP' || this.inventory.code === 'SAQ');
    },
    labelPrice(){
      return this.inventory!= null && this.inventory.code === 'IP' ? "Prix titulaire" : "Prix de vente";
    },
    considerItemPriceVariation(){
      if(localStorage.CONSIDER_ITEM_PRICE_VARIATION==null)return false;
      return JSON.parse(localStorage.CONSIDER_ITEM_PRICE_VARIATION).active;
    },
    maximumItemPriceVariation(){
      if(localStorage.CONSIDER_ITEM_PRICE_VARIATION==null)return false;
      return JSON.parse(localStorage.CONSIDER_ITEM_PRICE_VARIATION).maximum_item_price_variation;
    },
    minimumItemPriceVariation(){
      if(localStorage.CONSIDER_ITEM_PRICE_VARIATION==null)return false;
      return JSON.parse(localStorage.CONSIDER_ITEM_PRICE_VARIATION).minimum_item_price_variation;
    },
    calculateQuantityUVC(){
      return localStorage.CALCULATE_QUANTITY_UVC!=null&&localStorage.CALCULATE_QUANTITY_UVC==='1';
    },
    dateModel : {
      set(date){this.setPurchaseReceiveProp({date})},
      get(){return this.purchaseReceive.date;}
    },
    notes : {
      set(notes){this.setPurchaseReceiveProp({notes})},
      get(){return this.purchaseReceive.notes}
    },
    ...mapState('purchaseReceiveDialog', ['purchaseReceive','loading', 'purchaseReceiveStatus', 'inventory'])
	},
  created(){

  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

.warning-row {
    background: oldlace !important;
  }

.success-row {
    background: #f0f9eb;
  }

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-20px;
  padding-top:10px;
  border-top:1px solid #E4E7ED;
  z-index:1000;
}

.el-input__inner{
  border:0px;
}
.title {
	font-size : 1.6em;
	font-weight:bold;

}

.formContainer{
    margin-left:10%;
    width:80%;
  }

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}

</style>
